/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_ProviderInputs */

const en_settings_payments_provider = /** @type {(inputs: Settings_Payments_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

const zh_settings_payments_provider = /** @type {(inputs: Settings_Payments_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付方式`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Settings_Payments_ProviderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_payments_provider = /** @type {((inputs?: Settings_Payments_ProviderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_ProviderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_payments_provider(inputs)
	return zh_settings_payments_provider(inputs)
});
export { settings_payments_provider as "settings.payments.provider" }